<template>
  <section class="container-onboarding-content">
    <div class="wrapper-country">
      <h3 class="title">{{ t('sign_up') }}</h3>
    </div>

    <!-- 국가 -->
    <div class="wrapper-country">
      <p class="accent">{{ t('label_select_country') }}</p>
      <DropdownCountry v-model="form.countryCode" />
    </div>

    <!-- 추천인 -->
    <div class="wrapper-country">
      <p class="accent">{{ t('referral_code') }}</p>
      <input v-model="form.referralCode" type="text" :placeholder="t('referral_code_placeholder')" />
    </div>

    <!-- 전체동의 -->
    <div class="wrapper-selections">
      <Checkbox v-model="isAllChecked">
        <span class="accent">{{ t('agree_to_all') }} </span>
      </Checkbox>
    </div>

    <!-- 서비스 이용약관 -->
    <div class="wrapper-selections">
      <Checkbox v-model="form.isAgreedUsage">
        {{ t('policy_service') }} <span class="dim">({{ t('required') }})</span>
      </Checkbox>
      <a @click="moveToPolicyPage('service')">{{ t('view_details') }}</a>
    </div>

    <!-- 개인정보처리방침 -->
    <div class="wrapper-selections">
      <Checkbox v-model="form.isAgreedPersonal">
        {{ t('policy_privacy') }} <span class="dim">({{ t('required') }})</span>
      </Checkbox>
      <a @click="moveToPolicyPage('privacy')">{{ t('view_details') }}</a>
    </div>

    <!-- 결제 및 환불정책 -->
    <div class="wrapper-selections">
      <Checkbox v-model="form.isAgreedPayment">
        {{ t('policy_payment') }} <span class="dim">({{ t('required') }})</span>
      </Checkbox>
      <a @click="moveToPolicyPage('payment')">{{ t('view_details') }}</a>
    </div>

    <!-- 정보저장 -->
    <div class="wrapper-selections">
      <Checkbox v-model="form.isAgreedStorage">
        {{ t('policy_cookie') }} <span class="dim">({{ t('optional') }})</span>
      </Checkbox>
      <a @click="moveToPolicyPage('privacy')">{{ t('view_details') }}</a>
    </div>

    <!-- 마케팅 정보 수신 동의 -->
    <div class="wrapper-selections">
      <Checkbox v-model="form.isAgreedMarketing">
        {{ t('policy_marketing') }} <span class="dim">({{ t('optional') }})</span>
      </Checkbox>
      <!-- <a @click="moveToPolicyPage('privacy')">{{ t('view_details') }}</a> -->
    </div>
  </section>
</template>

<script setup lang="ts">
import { fetchUserCountry } from '@/api/apiService';
import Checkbox from '@/components/shared/base/Checkbox.vue';
import DropdownCountry from '@/components/shared/composite/DropdownCountry.vue';
import { useModalPolicy } from '@/composables/domains/self-service/useModalPolicy';
import { ISelfServiceOnboardingForm } from '@/types/components';

const form = defineModel<ISelfServiceOnboardingForm>({
  required: true,
  default: () => ({}) as ISelfServiceOnboardingForm,
});

const { t } = useI18n();

const { setPolicyCurrent, openModalPolicy } = useModalPolicy();

const AGREEMENT_KEYS = [
  'isAgreedUsage',
  'isAgreedPersonal',
  'isAgreedPayment',
  'isAgreedStorage',
  'isAgreedMarketing',
] as const;

// 전체선택 상태
const isAllChecked = computed({
  get() {
    return AGREEMENT_KEYS.every((key: string) => form.value[key]);
  },
  set(val: boolean) {
    AGREEMENT_KEYS.forEach((key) => {
      form.value[key] = val;
    });
  },
});

// 정책 페이지 이동
const moveToPolicyPage = (id: string) => {
  setPolicyCurrent(id);
  openModalPolicy();
};

/**
 * @desc 사용자 위치 정보를 조회합니다.
 * */
const requestUserCountry = async () => {
  const { data: { countryIsoCode = '' } = { countryIsoCode: '' } } = await fetchUserCountry();

  if (countryIsoCode) {
    form.value.countryCode = countryIsoCode;
  }
};

onMounted(async () => {
  await requestUserCountry();
});
</script>

<style scoped lang="scss">
.container-onboarding-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.wrapper-country {
  display: flex;
  flex-direction: column;
  gap: 0.325rem;
}

.wrapper-selections {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
